var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createContext, useState } from 'react';
;
export var MAESTRO_QUERY_CLIENT_CONTEXT_DATA_DEFAULT = {
    baseURL: undefined,
};
export var MaestroQueryClientContext = createContext(MAESTRO_QUERY_CLIENT_CONTEXT_DATA_DEFAULT);
export var useMaestroQueryClientContext = function (params) {
    var paramsBaseURL = params.baseURL;
    var _a = __read(useState(paramsBaseURL), 1), baseURL = _a[0];
    return { baseURL: baseURL };
};
//# sourceMappingURL=MaestroQueryClientContext.js.map